const live = {
  // 禁言用户列表
  muteUserList: `/liveApi/api/v2/user/muteUserList`,
  // 查询用户
  searchUser: `/liveApi/api/v2/user/searchUser`,
  // 查询用户封禁状态
  getAudienceState: `/liveApi/api/v2/user/getAudienceState`,
  // 解除禁言记录列表
  unlockMuteList: `/liveApi/api/v2/user/unlockMuteList`,
  // 解除禁言
  unlockMute: `/liveApi/api/v2/user/unlockMute`,
  // 直播配置参数：清晰度、禁言时长
  roomConfig: `/liveApi/api/v3/Room/config`,
  // 禁言观众/添加
  muteUser: `/liveApi/api/v2/user/muteUser`,
  // 直播间拉黑用户
  addRoomBlack: `/liveApi/api/v2/user/addRoomBlack`,
  // 屏蔽词列表
  blackWordsList: `/liveApi/api/v1/Live/blackWordsList`,
  // 删除屏蔽词
  delBlackWord: `/liveApi/api/v1/Live/delBlackWord`,
  // 添加直播间屏蔽词
  addBlackWord: `/liveApi/api/v1/Live/addBlackWord`,
  // 收礼列表
  receivedGiftList: `/liveApi/api/v2/Gift/receivedGiftList`,
  // 关注/取关
  doFollow: `/liveApi/api/v2/user/doFollow`,
  // 直播列表
  liveList: `/liveApi/api/v2/live/liveList`,
  // 搜索直播列表 -- 刘阳
  searchLiveList: `/liveApi/api/v6/Home/searchLiveList`,
  // 搜索关键字 -- 刘阳
  searchKeyMatch: `/liveApi/api/v3/Home/searchKeyMatch`,
  // 搜索关键字(new) -- 刘阳
  pcSearchKeyMatch: `/liveApi/api/v6/Home/pcSearchKeyMatch`,
  // 获取优先级最高的赛事直播
  competitionLive: `/liveApi/api/v1/live/competitionLive`,
  // 直播间主播/观众直播心跳（只发观众即可）
  liveHeartbeat: `/liveApi/api/v1/user/liveHeartbeat`,
  // 宝箱任务信息
  boxTask: `/liveApi/api/v2/BoxTask/boxTask`,
  // 领取宝箱
  receiveBox: `/liveApi/api/v2/BoxTask/receiveBox`,
  // 宝箱余额明细
  balanceLog: `/liveApi/api/v2/BoxTask/balanceLog`,
  // 可充值游戏列表
  payGameList: `/liveApi/api/v2/BoxTask/payGameList`,
  // 宝箱币充值
  boxCoinRecharge: `/liveApi/api/v2/BoxTask/boxCoinRecharge`,
  // 获取用户信息
  userInfo: `/liveApi/api/v2/user/info`,
  // 盒币兑换元宝
  exchangeGoldIngot: `/liveApi/api/v3/Recharge/exchangeGoldIngot`,
  // 获取元宝数据
  getGoldIngotData: `/liveApi/api/v3/Recharge/getGoldIngotData`,
  // 邀请明细
  promoteUserList: `/liveApi/api/v4/Anchor/promoteUserList`,
  // 获取直播分类
  getLiveCategory: `/liveApi/api/v6/Home/liveCategory`,
  // 主播关闭提醒
  closeReminder: `/liveApi/api/v1/live/closeReminder`,
  // 获取房间屏蔽词
  blockingWords: `/liveApi/api/v2/User/blockingWords`,
  // 房间屏蔽词编辑保存
  blockingWordsSave: `/liveApi/api/v2/User/blockingWordsSave`,
  // 客户端预加载飘信息接口
  streamerStyle: `/authApi/notice/streamer/style`,
  // 获取主播基础信息
  getAnchorInfo: `/authApi/show/v1/anchor/live/info`,
  // 新数据概览 - 汇总
  newDataOverview: `/liveApi/api/v3/Anchor/dataOverview`,
  // 新数据概览 - 图表
  newDataCharts: `/liveApi/api/v3/Anchor/charts`,
  // 新数据概览 - 表格
  newDataTable: `/liveApi/api/v3/Anchor/lists`,
  // 违规例图
  violationPic: `/authApi/show/v1/anchor/violationPic`,
  // 初始化tab列表
  initData: `/liveApi/api/v1/Config/initData`,
  // 96秀导流卡片
  trafficRedirectingCard: `/liveApi/api/v6/Room/trafficRedirectingCard`,
  // 96秀推荐、关注直播列表
  liveList96Show: `/liveApi/api/v6/Home/liveList96Show`,
  // 获取美女关注小红点
  liveCategory96Show: `/liveApi/api/v6/Home/liveCategory96Show`
};

export default live;
